import _default from './Sticky';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Sticky/index.js
// module id = 700
// module chunks = 0